import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const SITE_URL = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://mulebuy.asia';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Mulebuy Spreadsheet",
            "url": SITE_URL,
            "description": "Best Mulebuy Spreadsheet 2026 featuring trusted sellers, QC guides, and latest finds for sneakers, clothing, bags, and accessories.",
            "potentialAction": {
              "@type": "SearchAction",
              "target": `${SITE_URL}/search?q={search_term_string}`,
              "query-input": "required name=search_term_string"
            }
          }),
        }}
      />
    </I18nextProvider>
  );
}

export default App;
